import React, { Component } from "react";
import {
  userUpdated,
  newPrimaryOwner,
  addCapability,
  removeCapability,
  makeOwner,
  removeOwner,
  makePrimaryOwner
} from "../actions/organization";

import { connect } from "react-redux";

import { Dropdown, Modal } from "semantic-ui-react";

const redStyle = {
  color: "#B03060"
};

const blueStyle = {
  color: "#0E6EB8"
};

const greyStyle = {
  color: "#A0A0A0"
};

const CAPABILITIES = [
  {
    name: "VIEW_REIMBURSEMENTS",
    description: "view reimbursements",
    icon: "clipboard check"
  },
  {
    name: "APPROVE_REIMBURSEMENTS",
    description: "approve reimbursements",
    icon: "clipboard check"
  },
  {
    name: "PAY_REIMBURSEMENTS",
    description: "pay reimbursements",
    icon: "clipboard check"
  },
  {
    name: "MODIFY_SUBMITTERS",
    description: "change reimbursement submitters",
    icon: "clipboard check"
  },
  {
    name: "MODIFY_ORGANIZATION",
    description: "modify organization settings",
    icon: "cogs"
  },
  {
    name: "VIEW_TRANSACTIONS",
    description: "view bank transactions",
    icon: "university"
  }
];

class CapabilitiesControlDropdown extends Component {
  removeOwner = () => {
    removeOwner(this.props.user.uuid).then(newUser =>
      this.props.userUpdated(newUser)
    );
  };

  makeOwner = () => {
    makeOwner(this.props.user.uuid).then(newUser =>
      this.props.userUpdated(newUser)
    );
  };

  addCapability = capability => {
    return () => {
      addCapability(this.props.user.uuid, capability).then(newUser =>
        this.props.userUpdated(newUser)
      );
    };
  };

  removeCapability = capability => {
    return () => {
      removeCapability(this.props.user.uuid, capability).then(newUser =>
        this.props.userUpdated(newUser)
      );
    };
  };

  makePrimaryOwner = () => {
    makePrimaryOwner(this.props.user.uuid).then(newUser => {
      this.props.newPrimaryOwner(newUser.uuid);
      this.props.userUpdated(newUser);
    });
  };

  renderOwner() {
    return (
      <Dropdown floating labeled button basic>
        <Dropdown.Menu className="left">
          <Dropdown.Item style={redStyle} onClick={this.removeOwner}>
            Revoke ownership
          </Dropdown.Item>
          <Modal
            trigger={
              <Dropdown.Item style={redStyle}>Make primary owner</Dropdown.Item>
            }
            header="Transferring primary ownership"
            size="tiny"
            content={
              "Transfer primary ownership to " +
              this.props.user.first_name +
              "? You cannot undo."
            }
            actions={[
              { key: "done", content: "Go back" },
              {
                primary: true,
                onClick: this.makePrimaryOwner,
                content: "Confirm",
                negative: true
              }
            ]}
          />
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  renderUser() {
    return (
      <Dropdown floating labeled button basic>
        <Dropdown.Menu className="left">
          {CAPABILITIES.map(capability => {
            if (this.props.user.capabilities.includes(capability.name)) {
              return (
                <Dropdown.Item
                  style={greyStyle}
                  key={capability.name}
                  onClick={this.removeCapability(capability.name)}
                >
                  Remove "{capability.description}"
                </Dropdown.Item>
              );
            } else {
              return (
                <Dropdown.Item
                  key={capability.name}
                  onClick={this.addCapability(capability.name)}
                >
                  Allow "{capability.description}"
                </Dropdown.Item>
              );
            }
          })}
          {this.props.me.is_primary_owner && [
            <Dropdown.Divider key="dropdown-divider" />,
            <Dropdown.Item
              key="dropdown-item"
              style={blueStyle}
              onClick={this.makeOwner}
            >
              Make owner
            </Dropdown.Item>
          ]}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  render() {
    if (!this.props.me.is_owner) {
      return <div />;
    } else if (!this.props.me.is_primary_owner && this.props.user.is_owner) {
      return <div />;
    } else if (this.props.me.uuid === this.props.user.uuid) {
      return <div />;
    }

    if (this.props.user.is_owner) {
      return this.renderOwner();
    }
    return this.renderUser();
  }
}

const mapStateToProps = (state, ownProps) => ({
  me: state.user
});

const mapDispatchToProps = dispatch => ({
  userUpdated: newUser => dispatch(userUpdated(newUser)),
  newPrimaryOwner: newPrimaryOwnerUUID =>
    dispatch(newPrimaryOwner(newPrimaryOwnerUUID))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CapabilitiesControlDropdown);



// WEBPACK FOOTER //
// ./frontend/src/components/CapabilitiesControlDropdown.js